import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ApplicationLayout as CoreApplicationLayout, ErrorBoundary, TrackNavigation } from "am-tax-fe-core";
import { Page } from "./Page";
import { settings } from "../utils/settings";
import { Loading } from "../components/Loading";

function ApplicationLayout() {
    const location = useLocation();

    return (
        <>
            <ErrorBoundary location={location}>
                <CoreApplicationLayout appName={settings.VITE_APP_NAME}>
                    <Suspense
                        fallback={
                            <Page title={""}>
                                <Loading />
                            </Page>
                        }
                    >
                        <Outlet />
                    </Suspense>
                </CoreApplicationLayout>
            </ErrorBoundary>
            <TrackNavigation location={location} />
        </>
    );
}

export default ApplicationLayout;
